import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [form, setForm] = useState({ email: "", password: "" });
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setErr("");
        const r = await login(form.email, form.password);
        setBusy(false);
        if (!r.ok) {
            setErr(r.error);
            toast.error(r.error);
            return;
        }
        toast.success(`Welcome back, ${r.user.name}.`);
        const dest = r.user.role === "sales_agent" ? "/agent" : "/admin";
        nav(loc.state?.from || dest, { replace: true });
    };

    return (
        <main data-testid="login-page" className="min-h-screen bg-black flex items-center justify-center px-6 pt-24 pb-12">
            <div className="w-full max-w-md">
                <Link to="/" className="font-serif text-3xl block mb-12">Tile<span className="text-gold">Sphere</span></Link>
                <div className="overline mb-3">Sign In</div>
                <h1 className="font-serif text-4xl mb-10 tracking-tight">Welcome back.</h1>

                <form onSubmit={submit} className="space-y-4" data-testid="login-form">
                    <input required type="email" placeholder="Email" value={form.email} onChange={(e)=>setForm(f=>({...f,email:e.target.value}))} className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none" data-testid="login-email" />
                    <input required type="password" placeholder="Password" value={form.password} onChange={(e)=>setForm(f=>({...f,password:e.target.value}))} className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none" data-testid="login-password" />
                    {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
                    <button disabled={busy} type="submit" className="btn-gold w-full disabled:opacity-50" data-testid="login-submit">{busy ? "Signing in…" : "Sign In"}</button>
                </form>

                <div className="mt-8 flex items-center justify-between text-sm text-white/60">
                    <Link to="/forgot-password" className="hover:text-gold">Forgot password?</Link>
                    <span className="text-white/40">Accounts are created by your administrator.</span>
                </div>

                <div className="mt-12 border-t border-white/10 pt-6 text-xs text-white/45 leading-relaxed">
                    <div className="overline mb-2">Demo Credentials</div>
                    Admin: <span className="text-white/70">admin@tilesphere.com</span> / <span className="text-white/70">Admin@2026</span><br />
                    Agent: <span className="text-white/70">agent@tilesphere.com</span> / <span className="text-white/70">Agent@2026</span>
                </div>
            </div>
        </main>
    );
}
